import React from 'react'
import {Util} from 'yougile-util'
import {noPropagate, useGlobalKeyDown} from '@containers/hooks'
import {MoveToBody} from '../../move-to-body'
import {usePopstateListener} from './use-popstate-listener'

interface Props extends React.PropsWithChildren<unknown> {
  width: number
  title: React.ReactNode
  footer?: React.ReactNode
  autoHeight?: boolean
  close: 'disabled' | (() => void)
  closeOnOverlayDisabled?: boolean
  className?: string
  contentClassName?: string
  minHeightAuto?: boolean
  noPropagateOverlay?: boolean
  noPropagateBody?: boolean
}

export const popupCloseSubscriptions: Record<string, () => void> = {}

/**
 * @deprecated This component is obsolete and will be removed soon. Use @components/common/base/popup instead.
 * @param props
 * @constructor
 */
export const Popup = (props: Props) => {
  const {
    title,
    close,
    children,
    footer,
    width,
    autoHeight,
    className,
    contentClassName,
    closeOnOverlayDisabled = false,
    minHeightAuto = false,
    noPropagateOverlay = false,
    noPropagateBody = false
  } = props
  const bem = className
    ? Util.bemFrom('popup', className.split(' '))
    : Util.bemFrom('popup')

  const closeWithSubs = (): boolean | void => {
    if (close && close !== 'disabled') {
      close()
      Object.values(popupCloseSubscriptions).forEach(f => f())
      return true
    }
  }

  useGlobalKeyDown({
    escape: closeWithSubs
  })

  const closeFunc = close !== 'disabled' ? closeWithSubs : undefined
  usePopstateListener(closeFunc)

  return (
    <MoveToBody className={bem()}>
      <div
        className={bem('overlay')}
        onClick={e => {
          noPropagateOverlay && noPropagate(e)
          !closeOnOverlayDisabled && closeWithSubs()
        }}
      />
      <div
        onClick={e => noPropagateBody && noPropagate(e)}
        className={bem('wnd')}
        style={{
          width,
          ...(autoHeight ? {height: 'auto'} : {}),
          ...(minHeightAuto ? {minHeight: 'auto'} : {})
        }}
      >
        <div className={bem('header')}>
          {title}
          {close !== 'disabled' && (
            <div className={bem('close')} onClick={closeWithSubs} />
          )}
        </div>

        <div className={bem('cnt') + ' ' + contentClassName}>{children}</div>
        {!!footer && <div className={bem('footer')}>{footer}</div>}
      </div>
    </MoveToBody>
  )
}
